var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{staticClass:"trip-details-status-badge",attrs:{"variant":_vm.BookingColorGenerator(_vm.state)}},[_c('span',[_vm._v(_vm._s(_vm.snakeCaseToCamelCase(_vm.state)))])])}
var staticRenderFns = []

export { render, staticRenderFns }